export * from './IconPVC';
export { default as IconPVC } from './IconPVC';
